<template>
  <div class="tax-invoice-request-display">
    <div class="card card-default mb-4">
      <h4
        class="card-header"
        v-html="title" />
      <div class="card-body">
        <p
          class="text-danger"
          v-if="!propertyPhotos.complete">
          <i class="fa fa-exclamation-triangle" /> Report Incomplete
        </p>
        <p class="text-muted">
          {{ propertyPhotos.StaffMember.fullName }} - <i class="far fa-clock fa-fw" /> {{ propertyPhotos.createdAt | date_time_format }}
          <span class="float-right" v-if="$user.administrator"><i class="fas fa-stopwatch fa-fw" /> Time spent: {{ timeSpent }}</span>
        </p>
        <template v-if="propertyPhotos.TaxInvoiceRequest">
          <p>
            <strong>
              Tax Invoice Request
            </strong>
            <br>
            <download-input
              :options="{ label: propertyPhotos.TaxInvoiceRequest.referenceNumber, permalink: 'downloadFile'}"
              :value="{ objectKey: propertyPhotos.TaxInvoiceRequest.InvoiceRequestPdf.objectKey }" />
          </p>
          <p v-if="propertyPhotos.TaxInvoiceRequest.UploadedInvoice">
            <strong>
              Uploaded Invoice
            </strong>
            <br>
            <download-input
              :options="{ label: propertyPhotos.TaxInvoiceRequest.UploadedInvoice.fileName, permalink: 'downloadFile'}"
              :value="{ objectKey: propertyPhotos.TaxInvoiceRequest.UploadedInvoice.objectKey }" />
          </p>
        </template>
        <template v-if="propertyPhotos.SentEmails.length">
          <sent-email
            v-for="email in propertyPhotos.SentEmails"
            :key="email.uuid"
            :email="email">
          </sent-email>
        </template>
      </div>
      <div class="card-footer">
        <router-link
          :to="{ path: 'edit/' + propertyPhotos.uuid, append: true }"
          class="my-1 btn btn-black">
          <i class="far fa-fw fa-edit" /> Edit
        </router-link>
        <router-link
          target="_blank"
          :to="{ path: '/api/public/pdf/' + propertyPhotos.uuid + '?m=PropertyPhotosReport' }"
          class="my-1 btn btn-secondary"
          :class="{ 'disabled': !propertyPhotos.ReportPdfUuid }">
          <i class="fa fa-fw fa-search" /> Preview
        </router-link>
        <download-input
          :disabled="!propertyPhotos.ReportPdfUuid"
          :options="{ button: true, permalink: 'downloadFile'}"
          :value="{ objectKey: propertyPhotos.ReportPdf ? propertyPhotos.ReportPdf.objectKey : '' }" />
        <button
          class="my-1 btn btn-primary"
          @click="generatePdf()">
          <i class="fa fa-fw fa-redo-alt" /> Generate PDF
        </button>
        <button
          class="my-1 btn btn-success"
          @click="send()"
          :disabled="!propertyPhotos.complete">
          <i class="far fa-fw fa-paper-plane" /> Send
        </button>
        <button
          class="my-1 btn btn-lime"
          @click="duplicate()">
          <i class="far fa-fw fa-copy" /> Duplicate
        </button>
        <router-link
          :to="'/tax-invoice-requests/new/' + propertyPhotos.uuid + '?t=PropertyPhotosReport'"
          class="my-1 btn btn-warning"
          :class="{ 'disabled': !generateInvoiceButton }">
          <i class="fa fa-fw fa-dollar-sign" /> Invoice Request
        </router-link>
        <button
          @click="deletePropertyPhotosReport()"
          class="my-1 btn btn-danger">
          <i class="fa fa-fw fa-trash" /> Delete
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    DELETE_REPORT,
    DUPLICATE_PROPERTY_PHOTOS_REPORT,
    GENERATE_PROPERTY_PHOTOS_PDF,
    SEND_PROPERTY_PHOTOS_REPORT
  } from '@/vuex/types'
  import SentEmail from '@/components/displays/SentEmail'
  import DownloadInput from '@/components/inputs/DownloadInput'
  export default {
    name: 'PropertyPhotosReportDisplay',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      SentEmail,
      DownloadInput
    },
    computed: {
      timeSpent () {
        let minutes = this.propertyPhotos.time / 60.0
        if (minutes > 120) {
          let hours = minutes / 60
          return hours.toFixed(2) + ' hours'
        } else {
          return minutes.toFixed(2) + ' min'
        }
      },
      fileName () {
        if (this.propertyPhotos.ReportPdf) {
          return this.propertyPhotos.ReportPdf.fileName.slice(0, -4)
        } else {
          return this.propertyPhotos.propertyAddress
        }
      },
      generateInvoiceButton () {
        return this.propertyPhotos.complete && !this.propertyPhotos.TaxInvoiceRequestUuid
      },
      title () {
        if (this.propertyPhotos.propertyAddress) {
          return '<i class="fa fa-fw fa-map-marker-alt"></i> ' + this.propertyPhotos.propertyAddress
        } else {
          return '<i class="fa fa-fw fa-certificate"></i> New Report'
        }
      },
      propertyPhotos () {
        return {
          StaffMember: {},
          ...this.object
        }
      }
    },
    methods: {
      async deletePropertyPhotosReport () {
        await this.$store.dispatch(DELETE_REPORT, {
          reportUuid: this.propertyPhotos.uuid,
          reportType: 'PropertyPhotosReport'
        })
      },
      async generatePdf () {
        await this.$store.dispatch(GENERATE_PROPERTY_PHOTOS_PDF, this.propertyPhotos)
      },
      async duplicate () {
        await this.$store.dispatch(DUPLICATE_PROPERTY_PHOTOS_REPORT, this.propertyPhotos.uuid)
      },
      async send () {
        await this.$store.dispatch(SEND_PROPERTY_PHOTOS_REPORT, this.propertyPhotos.uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/PropertyPhotosReport.vue